import axios from 'axios';

let redirecting = false;

const storedToken = (storage, key) => {
  try {
    return JSON.parse(storage.getItem(key))?.token || null;
  } catch (_) {
    return null;
  }
};

export const expireSession = () => {
  if (redirecting) return;
  redirecting = true;
  sessionStorage.removeItem('currentUser');
  localStorage.removeItem('UserAuth');
  window.location.replace('/login?sessionExpired=1');
};

export const tokenExpirationTime = (token) => {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return Number.isFinite(decoded.exp) ? decoded.exp * 1000 : null;
  } catch (_) {
    return null;
  }
};

export const shouldExpireForUnauthorized = (error) => {
  if (error.response?.status !== 401) return false;
  const authorization = error.config?.headers?.get?.('Authorization')
    || error.config?.headers?.Authorization
    || error.config?.headers?.authorization;
  const token = /^Bearer\s+(.+)$/i.exec(authorization || '')?.[1];
  if (!token || token === 'null' || token === 'expired') return false;
  return token === storedToken(sessionStorage, 'currentUser')
    || token === storedToken(localStorage, 'UserAuth');
};

export const installSessionExpiryInterceptor = () => {
  const interceptor = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (shouldExpireForUnauthorized(error)) expireSession();
      return Promise.reject(error);
    }
  );
  return () => axios.interceptors.response.eject(interceptor);
};
